import { render, staticRenderFns } from "./cn_pinglun.vue?vue&type=template&id=76ae823a&scoped=true&"
import script from "./cn_pinglun.vue?vue&type=script&lang=js&"
export * from "./cn_pinglun.vue?vue&type=script&lang=js&"
import style0 from "./cn_pinglun.vue?vue&type=style&index=0&id=76ae823a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ae823a",
  null
  
)

export default component.exports